import { Controller, useFormContext } from "react-hook-form";
import Box from "@mui/material/Box";
import { AUTOMATICALLY_TAG_PRODUCTS } from "../../../../../i18n/keysTranslations";
import Switch from "../../../../Form/Switch";

const ProductTagsForm = () => {
  const { control } = useFormContext();

  return (
    <Box
      sx={{
        ml: 0.5,
      }}
    >
      <Controller
        name="value"
        control={control}
        render={({ field }) => (
          <Switch
            isActive={field.value}
            onChangeIsActive={(value) => field.onChange(value)}
            labelActive={AUTOMATICALLY_TAG_PRODUCTS}
            labelDeactivate={AUTOMATICALLY_TAG_PRODUCTS}
          />
        )}
      />
    </Box>
  );
};

export default ProductTagsForm;
